import React from 'react'
import { Modal } from 'react-bootstrap'
import AloModal from '../../AloModal'
import PropTypes from 'prop-types'

const ReportPlaylistModal = ({ playlist, show, onHide }) => {
  return (
    <AloModal show={show} onHide={onHide}>
      <Modal.Header>Report Playlist</Modal.Header>
      <Modal.Body>
        Are you sure you want to report this playlist for offensive or
        inappropriate content?
      </Modal.Body>
      <Modal.Footer>
        <button className='grey' onClick={onHide}>
          Cancel
        </button>
        <button
          className='btn alo-button delete-btn'
          onClick={() => {
            playlist.report().then(() => {
              onHide()
            })
          }}
        >
          Report
        </button>
      </Modal.Footer>
    </AloModal>
  )
}

ReportPlaylistModal.propTypes = {
  playlist: PropTypes.object,
  show: PropTypes.bool,
  onHide: PropTypes.func
}

export default ReportPlaylistModal
